import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "level-range-slider-mobile__tooltip-text" }
const _hoisted_2 = { class: "level-range-slider-mobile__labels" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_ElSlider = _resolveComponent("ElSlider")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: _ctx.width }),
    class: "level-range-slider-mobile"
  }, [
    _createVNode(_component_ElTooltip, {
      modelValue: _ctx.showTooltipOverreached,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTooltipOverreached) = $event)),
      "visible-arrow": false,
      effect: "dark",
      placement: "top",
      "popper-class": "level-range-slider-mobile__tooltip-transform el-abaca-tooltip"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("i", null, [
            _cache[7] || (_cache[7] = _createTextVNode(" There’s a limit ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("b", null, "range of 4 levels", -1)),
            _cache[9] || (_cache[9] = _createTextVNode(" . ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
            _cache[11] || (_cache[11] = _createTextVNode(" For a wider range ", -1)),
            _createElementVNode("b", null, [
              _createElementVNode("span", {
                class: "tooltip-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.rangeTipButtonClickHandler && _ctx.rangeTipButtonClickHandler(...args)))
              }, " get in touch "),
              _cache[6] || (_cache[6] = _createTextVNode(" with us. ", -1))
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("span", null, null, -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ElSlider, {
      ref: "slider",
      modelValue: _ctx.innerValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.innerValue) = $event)),
      max: _ctx.levels,
      min: 1,
      "show-tooltip": false,
      step: 1,
      width: { width: _ctx.width },
      class: "level-range-slider-mobile__inner",
      range: "",
      "show-stops": "",
      onChange: _cache[3] || (_cache[3] = () => _ctx.changeLevelHandler),
      onInput: _cache[4] || (_cache[4] = () => _ctx.handleRangeSliderInputChange)
    }, null, 8, ["modelValue", "max", "width"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stops, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (index !== 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: item,
                class: _normalizeClass([_ctx.currentLevelState(index), "level-range-slider-mobile__level-label"]),
                style: _normalizeStyle({ left: 'calc(' + item + '% - 4px)' })
              }, [
                _createElementVNode("span", null, _toDisplayString(index), 1)
              ], 6))
            : _createCommentVNode("", true),
          (index !== 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 'stop-' + item,
                class: _normalizeClass([{
            'is-active': _ctx.isLevelBeingSelected(index),
          }, "level-range-slider-mobile__stop"]),
                style: _normalizeStyle({ left: item + '%' })
              }, [
                (index === 1)
                  ? (_openBlock(), _createBlock(_component_ElTooltip, {
                      key: 0,
                      modelValue: _ctx.showTooltip,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showTooltip) = $event)),
                      effect: "dark",
                      placement: "top",
                      "popper-class": "level-range-slider-mobile__tooltip el-abaca-tooltip"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "level-range-slider-mobile__tooltip-text",
                          innerHTML: _ctx.entryTooltip
                        }, null, 8, _hoisted_3)
                      ]),
                      default: _withCtx(() => [
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, null, -1))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ], 6))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ], 4))
}